<template>
  <el-row :gutter="20">


    <el-col :span="12">
        <div class="font_1">
            <div>Learn today's most</div>
            in- <span class="font_2">demand-skills</span>
        </div>
        <div class="font_3">
            来到这里你可以学习更加丰富的知识, 学习更多专业的技能,<br> 
            在知识的海洋里遨游, 学无止境。
        </div>
        <div class="font_4">
           <div style="margin-bottom: 10px"> <img class="yesImg" src="@/assets/img/card/yes.png"> <span>“开启你的学习之旅，探索微专业课程，成就未来的自己！”</span> <br></div>
           <div style="margin-bottom: 10px"> <img class="yesImg" src="@/assets/img/card/yes.png"> <span>“聚焦专业，精准定位，微专业，助你实现职业梦想！”</span> <br></div>
           <div style="margin-bottom: 10px"> <img class="yesImg" src="@/assets/img/card/yes.png"> <span>“勇敢探索，不断前行，让学习成为你的力量之源！”</span> <br></div>
           <div style="margin-bottom: 10px"> <img class="yesImg" src="@/assets/img/card/yes.png"> <span>“抓住每一次学习的机会，铸就坚实的学识基石，成就辉煌人生！”</span> <br></div>
        </div>

        <button type="button" class="btn btn-dark btn_font">
            <router-link class="nav-link" :to="{ name: 'course', params: { page: 1, cateId: 0, courseName: '' } }">
                探索-课程
            </router-link>
        </button>
    </el-col>
    <el-col :span="12">
        <img src="@/assets/img/card/header_buble_01.svg" class="svg_1 svg">
        <img :src="$store.state.options.indexHeader" class="personImg">
        <img src="@/assets/img/card/header_buble_02.svg" class="svg_2 svg">
    </el-col>
  </el-row>
</template>

<script setup>

</script>

<style scoped>

.svg {
    width: 80px;
}

.svg_2 {
    float: right;
}

.font_1{
    padding-top: 100px;
    font-weight:600;
    font-size: 55px;
}

.font_2 {
    color: rgb(113, 20, 219);
    text-decoration: underline;
    text-decoration-color: rgb(255, 140, 8);
}

.font_3{
    margin-top: 20px;
    font-size: 20px;
    color: rgb(87, 87, 87);
}

.yesImg{
    width: 15px;
    margin-right: 5px;
}

.font_4{
    margin-top: 20px;
    font-size: 15px;
    color: rgb(109, 109, 109);
}

.btn_font {
    margin-top: 30px;
    width: 200px;
    height: 50px;
    font-size: 20px;
    font-weight:600;
}

.personImg {
    width: 520px;
    border-radius: 20px;
    z-index: 2;
    margin: 0px 100px;
}
</style>